export const setSecondaryAccountOwnersUtil = (
  newSecondaryAccountOwners,
  accountOwners
) => {
  const ids = newSecondaryAccountOwners.map((ao) => ao.id)
  const existingIds = accountOwners.map((ao) => ao.id)

  accountOwners = accountOwners
    .filter((ao) => ao.isPrimary || ids.includes(ao.id))
    .map((ao) => ({
      ...ao,
      isPrimary: !ids.includes(ao.id),
    }))

  const newItems = newSecondaryAccountOwners
    .filter((ao) => !existingIds.includes(ao.id))
    .map((ao) => ({ ...ao, isPrimary: false }))

  return [...accountOwners, ...newItems]
}

export const setPrimaryAccountOwnerUtil = (identity, accountOwners) => {
  if (!identity) {
    return accountOwners.filter((ao) => !ao.isPrimary)
  }

  let newVal = accountOwners.map((ao) => ({
    ...ao,
    isPrimary: ao.id === identity.id,
  }))

  const existing = accountOwners.find((ao) => ao.id === identity.id)

  if (!existing) newVal = [...accountOwners, { ...identity, isPrimary: true }]

  return newVal
}
